import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { Sun, PlusCircle, User, Stethoscope, TrendingUp } from 'lucide-react';
import { SectionValue } from '../types';

interface BottomNavProps {
  currentSection: SectionValue;
  onSectionChange: (section: SectionValue) => void;
}

const sections: { value: SectionValue; label: string; icon: React.ReactNode }[] = [
  { value: 'today', label: 'Today', icon: <Sun size={22} /> },
  { value: 'log', label: 'Log', icon: <PlusCircle size={22} /> },
  { value: 'body', label: 'Body', icon: <User size={22} /> },
  { value: 'health', label: 'Health', icon: <Stethoscope size={22} /> },
  { value: 'insights', label: 'Insights', icon: <TrendingUp size={22} /> },
];

export const BottomNav: React.FC<BottomNavProps> = ({ currentSection, onSectionChange }) => {
  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        borderTop: '1px solid',
        borderColor: 'divider',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
      elevation={0}
    >
      <BottomNavigation
        value={currentSection}
        onChange={(_, newValue) => onSectionChange(newValue)}
        showLabels
      >
        {sections.map((s) => (
          <BottomNavigationAction
            key={s.value}
            value={s.value}
            label={s.label}
            icon={s.icon}
            sx={{
              '&.Mui-selected': {
                '& .MuiBottomNavigationAction-label': {
                  fontSize: '0.7rem',
                  fontWeight: 600,
                },
              },
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.65rem',
                fontWeight: 500,
                mt: 0.25,
              },
            }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};
